import React, { FC, HTMLProps } from 'react';

import { LucidTheme } from '@lucid/theme';

import Text, { TextProps } from '../../text/text';

export interface LabelProps extends Omit<HTMLProps<HTMLLabelElement>, 'as'> {
  /** Allows the component to get additional styles. */
  className?: string;
  /** Checks if the field is disabled. */
  isDisabled?: boolean;
  /** Checks if the field is hidden. */
  isHidden?: boolean;
  /** Checks if the field is required to submit and displays an asterick. */
  isRequired?: boolean;
}

const Label: FC<LabelProps & TextProps> = ({
  className,
  htmlFor,
  isDisabled = false,
  isHidden = false,
  isRequired = false,
  label,
  variant = 'labelS400',
  ...rest
}) => (
  <Text
    {...rest}
    aria-disabled={isDisabled}
    as="label"
    css={(theme: LucidTheme) => [
      {
        label: 'label',
      },
      isRequired && {
        '&::after': {
          content: '"*"',
          color: theme.colors.pink[60],
          paddingLeft: '5px',
        },
      },
      isDisabled && {
        color: theme.colors.coolGrey[60],
      },
      isHidden && {
        display: 'none',
        visibility: 'hidden',
      },
    ]}
    // eslint-disable-next-line react/jsx-sort-props
    className={className}
    data-testid={`formLabel-${htmlFor}`}
    htmlFor={htmlFor}
    variant={variant}
  >
    {label}
  </Text>
);

export { Label };
export default Label;
